import React from 'react';
import { Pressable } from "react-native";
export const CarouselDisplayContainer = ({ children, style, onDisplayScroll = (_) => { }, }) => {
    return (React.createElement(Pressable, { style: style, onHoverIn: () => onDisplayScroll(true), onHoverOut: () => onDisplayScroll(false) }, children));
};
//# sourceMappingURL=CarouselDisplayContainer.web.js.map